module.exports = __webpack_public_path__ + "img/cat4.6867b70b.svg";